import React from "react";
import { Col, Row } from "react-bootstrap";
import ModuleAccess from "../../context/moduleAccess";
import AppLayoutSecondaryHeader from "../layout/AppLayout/AppLayoutSecondaryHeader";

import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import { IconMenu } from "../../utils";
const Settings = (props) => {
  return (
    <>
      <AppLayoutSecondaryHeader title="Settings" />
      <div className="container mt-115">
        <Row>
          <ModuleAccess module="agent_mgt" action="action_list">
            <Col md={2} xs={6} className="mb-2">
              <IconMenu
                icon={<PeopleAltIcon sx={{ fontSize: 45 }} />}
                title="Agencies"
                to="/app/agents"
              />
            </Col>
          </ModuleAccess>
          <ModuleAccess module="modules" action="action_list">
            <Col md={2} xs={6} className="mb-2">
              <IconMenu
                icon={<SettingsBrightnessIcon sx={{ fontSize: 45 }} />}
                title="Modules"
                to="/app/settings/modules"
              />
            </Col>
          </ModuleAccess>
          <ModuleAccess module="user_roles" action="action_list">
            <Col md={2} xs={6} className="mb-2">
              <IconMenu
                icon={<ManageAccountsIcon sx={{ fontSize: 45 }} />}
                title="User Roles"
                to="/app/settings/roles"
              />
            </Col>
          </ModuleAccess>
          <ModuleAccess module="user_logins" action="action_list">
            <Col md={2} xs={6} className="mb-2">
              <IconMenu
                icon={<PeopleAltIcon sx={{ fontSize: 45 }} />}
                title="User Logins"
                to="/app/settings/user-logins"
              />
            </Col>
          </ModuleAccess>
          <ModuleAccess module="payment_gateways" action="action_list">
            <Col md={2} xs={6} className="mb-2">
              <IconMenu
                icon={<AccountBalanceWalletIcon sx={{ fontSize: 45 }} />}
                title="Payment Gateways"
              />
            </Col>
          </ModuleAccess>
        </Row>
      </div>
    </>
  );
};
export default Settings;
